<template>
  <div id="IDaaS" class="idaas">
    <c-banner :data="banner"></c-banner>
    <c-anchor-menu :menuData="anchorMenuData" :active="menuActive" @onClick="handleMenuClick" />
    <div class="idaas-content" :style="{'margin-top': anchorMenuFixed ? '90px' : 0}">
      <div class="content-left">
        <c-vertical-anchor-menu :menuData="anchorMenuData" :active="verticalAnchorMenuActive" @onClick="handleMenuClick" />
      </div>
      <div class="content-right">
        <c-textAndImg2
          class="content"
          v-for="(item,index) in contentData"
          :key="'IDaaS_content_'+index"
          :data="item"
          ref="content">
        </c-textAndImg2>
      </div>
    </div>
    <c-AD></c-AD>
  </div>
</template>
<script>
import CBanner from "@/components/Banner/index"
import CAD from "@/components/AD"
import CTextAndImg2 from "@/components/Content/textAndImg2"
import CAnchorMenu from "@/components/anchorMenu/index"
import CVerticalAnchorMenu from "@/components/verticalAnchorMenu/index"
import { bannerData, contentData, anchorMenuData } from "./data"
import {handleMenuClick} from "@/api/common"
export default {
  data() {
    return {
      banner: bannerData,
      contentData: contentData,
      anchorMenuData: anchorMenuData,
      menuActive: '',
      verticalAnchorMenuActive: ''
    }
  },
  computed: {
    ...Vuex.mapGetters([
      'anchorMenuFixed'
    ]),
  },
  components: {
    CBanner,
    CTextAndImg2,
    CAD,
    CAnchorMenu,
    CVerticalAnchorMenu
  },
  mounted() {
    this.menuActive = this.contentData[0].anchor
    this.verticalAnchorMenuActive = this.contentData[0].anchor
    this.$store.commit('SET_HANDLE_SCROLL', () => {
      this.handleScroll()
    })
  },
  methods: {
    handleMenuClick(data, index) {
      this.menuActive = data.anchor
      const targetOffsetTop = this.$refs.content[index].$el.offsetTop
      console.log(targetOffsetTop + 910)
      handleMenuClick(targetOffsetTop + 910)
    },
    handleScroll() {
      const contents = this.$refs.content
      for (let i in contents) {
        const content = contents[i].$el.getBoundingClientRect();
        // 计算可视区域
        let visiblePart = window.innerHeight - 90 - Math.abs(content.top)
        if (visiblePart >= (content.height) / 3) {
          this.verticalAnchorMenuActive= this.anchorMenuData[i].anchor
          this.menuActive= this.anchorMenuData[i].anchor
          return
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.idaas {
  & .idaas-content {
    flex(row, nowrap, flex-start, flex-start);
    width: 100%;
    position: relative;

    & .content-left {
      width: 13%;
      min-width: 13%;
    }

    & .content-right {
      width: 87%;
    }

  }
}
>>> .content {
  & .img {
    & img {
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
